import React from 'react';
import { pick, prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { Link } from 'js/components/common/Link';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import style from './Logo.scss';

// #region @theme
import { useDTAG } from '@theme/js/hooks/useDTAG';

interface LogoProps {
    isSportsbook?: boolean;
}
// #endregion

export const Logo: React.FC<LogoProps> = ({ isSportsbook }) => { // @theme
    const formFactor = useDeviceSelector(prop('formFactor'));
    const {
        customization: { siteLogoPath = '' } = {}, requestStamp, themeName, siteLogoConfigurations
    } = useAppSelector(pick([
        'customization', 'requestStamp', 'themeName', 'siteLogoConfigurations'
    ]));
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const casinoname = searchParams.get('casinoname');
    const site = searchParams.get('site');
    const params = new URLSearchParams({
        t: `${requestStamp}`,
        ...casinoname && { casinoname },
        ...site && { site }
    });

    // #region @theme
    const logoLink = useDTAG('LOGO_LINK');
    const logoFileName = isSportsbook ? 'logoSportsBook.svg' : 'logo.svg';
    // #endregion

    const logoURL = siteLogoPath
        ? `${siteLogoPath}?${params.toString()}`
        : `/${themeName}/images/${logoFileName}?${params.toString()}`; // @theme
    const { siteLogoWidth, siteLogoHeight } = siteLogoConfigurations[formFactor];

    return (
        <div className={`${style.logo} cms-default-header-logo`}>
            <Link href={logoLink || '/'}> {/* @theme */}
                <img
                    alt="logo"
                    src={logoURL}
                    style={{ width: siteLogoWidth, height: siteLogoHeight }}
                    className={`${style.logoImage} cms-default-header-logo-image`}
                />
            </Link>
        </div>
    );
};
